export default function ensureTokenPosition(arr) {
  const tokenIndex = arr.indexOf('token');
  // if 'token' is found and it's neither the first nor the last element
  if (tokenIndex !== -1 && tokenIndex !== 0 && tokenIndex !== arr.length - 1) {
    // remove 'token' from its current position
    arr.splice(tokenIndex, 1);
    // add 'token' to the start of the array
    arr.unshift('token');
  }

  return arr;
}
